import React from 'react';
import { Headline, Subtext } from '../../components/ScreenShell';
import { ChoiceCard } from '../../components/ui/Choice';
import { PrimaryButton } from '../../components/ui/PrimaryButton';
import { PRIORITY_OPTIONS } from '../../data/quizOptions';
import { toggleValue } from '../../types/quiz';
import type { StepProps } from '../../types/quiz';
const MAX = 2;
export function StepPriorities({
  profile,
  update,
  onNext
}: StepProps) {
  const reachedMax = profile.development_priorities.length >= MAX;
  return <div className="flex flex-1 flex-col" data-id="element-146" data-mp="2fw6xjqq5l92o">
      <Headline data-id="element-147" data-mp="2fxi603ujn504">¿Qué te gustaría ayudar a {profile.child_name} a fortalecer?</Headline>
      <Subtext data-id="element-148" data-mp="2twhsb4ul37t4">
        Selecciona hasta {MAX} opciones.{' '}
        <span className="font-semibold text-violet-600" data-id="element-149" data-mp="2ovu1oka9oszf">
          {profile.development_priorities.length}/{MAX}
        </span>
      </Subtext>

      <div className="mt-6 space-y-3" data-id="element-150" data-mp="9726koa829ac">
        {PRIORITY_OPTIONS.map(option => <ChoiceCard key={option.label} emoji={option.emoji} title={option.label} description={option.description} selected={profile.development_priorities.includes(option.label)} disabled={reachedMax} onSelect={() => update({
        development_priorities: toggleValue(profile.development_priorities, option.label, MAX)
      })} data-id="element-151" data-mp="45cwpbyqk1nu" />)}
      </div>

      <div className="mt-auto pt-10" data-id="element-152" data-mp="yavrzmfq4hml">
        <PrimaryButton onClick={onNext} disabled={profile.development_priorities.length === 0} data-id="element-153" data-mp="ybyeli60jxwp">
          Continuar →
        </PrimaryButton>
      </div>
    </div>;
}